import React from "react";
import * as constants from "../../../../const/constants";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "@material-ui/core/Button";
import Placeholder from "../../../../assets/img/common/placeholder.png";
import {lang, language} from "../../../../const/language";
import {BOUGHT_TEXT, RE_BUY_TEXT} from "../../../../const/constants";
import * as actionModalCreator from "../../../../store/domain/modal/action";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import * as actionSpinnerCreator from "../../../../store/domain/spinner/action";
import './lessonTile.scss'
// import Divider from "@mui/material/Divider";

class lessonViewTile extends React.Component {
    state = {
        lessons: []
    };
    viewLesson = (lesson) => {
        this.props.history.push({
            pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_SELECTED_LESSON_ROUTE}`,
            state: {
                ...lesson,
                btnStatus: BOUGHT_TEXT,
                firstWeek: this.props.firstWeek,
                classId: this.props.classId,
                isSeparated : true
            }
        })
    };
    purchaseHandler = (lessonId,lesson) => {
        console.log(lesson)
        this.props.setPaymentModal(true, {lessonId: lessonId,classDetails:lesson , physicalClass :  true})
    };

    async componentDidMount() {
        await this.setState({
            lessons: this.props.lessons
        })
    }

    render() {
        console.log(this.props);
        let lessons = this.state.lessons;
        return (
            <div className='main'>
                <div className="lesson-item-purchase">
                    <Row>
                        {
                            lessons.map((item, index) => {

                                const {buttonStatus} = item;

                                let lessonButton;

                                if(buttonStatus === "REPAY" || buttonStatus === "BUY"){
                                    lessonButton = (
                                        <Button
                                            className={"btn-orange com-btn bold-text mt-3"}
                                            onClick={() => this.purchaseHandler(item.id,item)}>
                                            {buttonStatus === "REPAY" ? language[lang].RePaidForTheLesson : language[lang].PurchaseTheLesson}
                                        </Button>
                                    )

                                }else if(buttonStatus === "PENDING"){
                                    lessonButton = (
                                        <Button className={"pending-btn-new com-btn bold-text"}
                                                onClick={() => this.viewLesson(item)}>
                                            {language[lang].PaymentPending}
                                        </Button>
                                    );

                                }else if(buttonStatus === "BOUGHT"){
                                    lessonButton = (
                                        <Button className={"btn-orange com-btn bold-text"}
                                                onClick={() => this.viewLesson(item)}>
                                            {language[lang].videosPDF}
                                       </Button>);
                                }

                                return (
                                    <Col sm={12} md={3} lg={3} key={index} className='colView'>
                                    <div>
                                        <div className={`slideshow-wrapper  border-0 card`}>
                                            <div className={"display-inline slideshow-user-wrapper"}>
                                                {/*<img*/}
                                                {/*    src={item.image ? item.image : Placeholder}*/}
                                                {/*    alt={"."}*/}
                                                {/*    className={"blur-img"}/>*/}
                                                <img
                                                    src={item.image ? item.image : Placeholder}
                                                    alt={"."}
                                                    className={"slideshow-pro-image"}/>
                                                <div className={"slideshow-middle"}>
                                                    <div className={"cursor  mb-3"}>
                                                        <Row>
                                                            <Col sm={12} md={12} lg={12}>
                                                                <div onClick={() => this.viewLesson(item)}>
                                                                    <h4 className={"l-topic"}>{item.name}</h4>
                                                                    {/*<Divider variant="middle" style={{marginBottom :  '6px', marginTop : '2px'}}/>*/}

                                                                    <Row className={"card-row"}>
                                                                        <Col xs="12"><p
                                                                            className={"description"}><i className="icofont-calendar mr-1 color-orange"/>{item.description}</p>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            </Col>

                                                            <Col sm={12} md={12} lg={12}>
                                                                <div className={"btn-ctrl"}>
                                                                    {lessonButton}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </Col>
                                )
                            })
                        }
                    </Row>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
    setPaymentModal: (data, value) => dispatch(actionModalCreator.setPaymentModal(data, value)),
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(lessonViewTile));


// export default lessonViewTile;